<template>
    <div>
        <div class="layout">
            <div class="layout__header">
                <div class="layout__title">
                    <h3>Ítems del comprobante</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Serie</th>
                                    <th>Descripción</th>
                                    <th>Cantidad disponible</th>
                                    <th>Cantidad seleccionada</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-show="idItem === '' || idItem === item.id_item" v-for="(item, index) in items" :key="index">
                                    <td>{{ item.id_item }}</td>
                                    <td>
                                        <input-field v-model="item.serie" :id="'serie' + index" placeholder="Escriba la serie..."></input-field>
                                    </td>
                                    <td>{{ item.descripcion_item }}</td>
                                    <td>{{ item.cantidad }}</td>
                                    <td>
                                        <input-field @input="validarCantidadSeleccionada(index)" v-model="item.cantidad_seleccionada" :id="'item' + index" placeholder="##.##" vMoney :format="decimal"></input-field>
                                    </td>
                                </tr>
                                <tr v-show="items.length === 0">
                                    <td colspan="5">
                                        <strong>No se ha encontrado registros.</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-buttons">
                <button @click="$emit('cancelar')" class="btn-danger btn--text" type="button"><i class="fa fa-ban"></i><span>Cancelar</span></button>
                <button @click="aceptar" class="btn-success" type="button"><i class="fa fa-check"></i><span>Aceptar</span></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : {
        value : {
            type : Array,
            required : false,
            default : function () {
                return [];
            }
        },
        idComprobante : {
            type : String,
            required : false
        },
        idItem : {
            type : String,
            required : false,
            default : ''
        }
    },
    data : function () {
        return {
            decimal : decimal,
            modelValue : this.value,
            items : [],
            url : url
        }
    },
    methods : {
        aceptar : function () {
            let itemsSeleccionados = [];
            for (let i = 0; i < this.items.length; i++)
            {
                let cantidadSeleccionada = parseFloat(this.items[i].cantidad_seleccionada);
                if (!isNaN(cantidadSeleccionada) && cantidadSeleccionada > 0)
                {
                    let item = this.seleccionarItem(this.items[i].id_item);
                    itemsSeleccionados.push({
                        codigo : this.items[i].id_item,
                        descripcion : this.items[i].descripcion_item,
                        cantidad : this.items[i].cantidad_seleccionada,
                        serie : this.items[i].serie,
                        cantidad_gr : item != null?item.cantidad_gr:0
                    });
                }
            }
            if (itemsSeleccionados.length === 0)
                swal('Debe seleccionar al menos uno de los items.', 'Mensaje', 'warning');
            else 
            {
                this.modelValue = itemsSeleccionados;
                this.$emit('input', this.modelValue);
            }
        },
        validarCantidadSeleccionada : function (index) {
            let item = this.items[index];
            let cantidad = parseFloat(item.cantidad);
            let cantidadSeleccionada = parseFloat(item.cantidad_seleccionada);
            if (!isNaN(cantidad) && !isNaN(cantidadSeleccionada)) {
                if (cantidadSeleccionada > cantidad)
                {
                    item.cantidad_seleccionada = cantidad;
                    swal('La cantidad seleccionada no puede ser mayor a la cantidad original.', 'Mensaje', 'warning');
                }
            }
        },
        cargarItemsComprobante : function () {
            if (this.idComprobante !== '') {
                let that = this;
                axios.get(this.url + '/comprobantes/' + this.idComprobante + '/items').then(function (response) {
                    let items = response.data;
                    for (let i = 0; i < items.length; i++)
                    {
                        let item = {
                            serie : '',
                            cantidad_seleccionada : 0,
                            id_item : items[i].id_item,
                            descripcion_item : items[i].descripcion_item,
                            cantidad : items[i].cantidad_disponible  
                        };
                        for (let j = 0; j < that.modelValue.length; j++) {
                            if (that.modelValue[j].codigo === items[i].id_item) {
                                let cantidadGr = parseFloat(that.modelValue[j].cantidad_gr);
                                if (isNaN(cantidadGr))
                                    cantidadGr = 0;
                                item.cantidad = parseFloat(item.cantidad) + cantidadGr;
                                item.cantidad_seleccionada = that.modelValue[j].cantidad;
                                item.serie = that.modelValue[j].serie; 
                                break;
                            }
                        }
                        that.items.push(item);
                    }
                        
                });
            }
        },
        seleccionarItem : function (idItem) {
            let that = this;
            for (let j = 0; j < that.modelValue.length; j++) {
                if (that.modelValue[j].codigo == idItem) {
                    return that.modelValue[j];
                }
            }
            return null;
        }
    },
    mounted : function () {
        this.cargarItemsComprobante();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ItemsComprobante.vue